// =============================
// Email: info@ebenmonney.com
// www.ebenmonney.com/templates
// =============================

export class Product
{
  public id: string;
  public reference: string;
  public description: string;
  public descriptionro: string;
  public descriptionen: string;
  public productgrup: string;
  public productnumber: string;
  public status: string;
  public pricedealer: number;
  public pricefinalcustomer: string;
  public descriptionfr: string;
  public catalogreference: string;
  public vehicleReference: string;
  public serialNumber: number;
  public selected: boolean;
  public selectedDependentProduct: boolean;
  public depedentProduct: string;
  public pricedealerCustomized: string;
  public pricefinalcustomerCustomized: string;
}

export class GetPhotosWitPoductGroupsViewModel {
  public carReference: string;
  public productList: Product[];
}
